import React from 'react';

import { Layout } from '@.layout';
import { Auth, LinkHelper } from '@/Services';

import { StoreClusterDashboard } from '../components';

export const StoreClusterDashboardServiceProviderPage = () => {
    const auth = Auth.Use();

    if (!auth?.user) {
        return <Layout nobg />;
    }

    if (!auth.user.sp_cluster) {
        // eslint-disable-next-line no-console
        console.error('Cluster required.');

        window.location.href = LinkHelper.myPage;

        return null;
    }

    return (
        <Layout nobg>
            <StoreClusterDashboard spStoreClusterId={auth?.user.sp_cluster.id} />
        </Layout>
    );
};
